<div [ngClass]="outerClass()" [class.card-basic]="showBoxStyle()">
  @if (isCollapseHeaderVisible()) {
    <div
      [ngClass]="[
        headerBackgroundColor(),
        showBoxStyle() ? headerMarginPadding() : '',
        'rounded-3',
        'pointer',
        isCollapsed() ? 'rounded-bottom-3' : '',
      ]"
      [class.card-basic-body]="showBoxStyle()"
      [class.card-basic]="!showBoxStyle()"
      [class.collapsed]="isCollapsed()"
      [attr.aria-controls]="collapseId()"
      [attr.aria-expanded]="!isCollapsed()"
      [attr.data-test]="collapseId()"
      (click)="collapse.toggle()"
    >
      <div [class.card-basic-body]="!showBoxStyle()">
        <div class="row">
          <div class="col my-auto">
            <div class="d-flex align-items-center justify-content-start">
              @if (iconClass()) {
                <i class="{{ iconClass() }}"></i>
              }
              <div>
                <h6 class="mb-0 {{ headerTextClass() }}" [translate]="titleMessageKey()" [translateParams]="headerTranslateParams()"></h6>
                @if (subtitleMessageKey()) {
                  <p
                    class="mt-1 mb-0 text--big {{ headerTextClass() }}"
                    [translate]="subtitleMessageKey()"
                    [translateParams]="headerTranslateParams()"
                  ></p>
                }
              </div>
            </div>
          </div>
          <div class="col-auto d-flex align-items-center justify-content-center">
            <button
              type="button"
              class="btn btn-icon btn-md float-end collapse-button {{ chevronButton() }}"
              [class.collapsed]="isCollapsed()"
              [attr.aria-controls]="collapseId()"
              [attr.aria-expanded]="!isCollapsed()"
              [attr.aria-label]="titleMessageKey() | translate: headerTranslateParams()"
              data-bs-toggle="collapse"
              role="button"
            >
              <i class="fas fw-normal fa-chevron-down transition-transform" [ngClass]="{ 'rotate-180': !isCollapsed() }"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <div
    #collapse="ngbCollapse"
    [ngbCollapse]="isCollapsed()"
    (ngbCollapseChange)="isCollapsed.set($event)"
    class="collapse"
    [class.show]="initialState() === 'expanded'"
  >
    <div class="py-0" [class.card-basic-body]="showBoxStyle()">
      <div class="{{ contentClass() }}" [ngClass]="{ 'border-top': headerTheme() === '' }">
        <ng-content />
      </div>
    </div>
  </div>
</div>
